import React, { Component } from 'react';
import API from '../api.js';
import Tools from '../tools';
import { connect } from 'react-redux';
import { useParams, NavLink, useLocation } from 'react-router-dom';
import { Col, Container, Row, Button } from 'react-bootstrap';

export default function CustomerHeader(props) {
    const params = useParams();
    Tools.init();
    // console.log("!!", props.location);
    let tmpID = "";
    if (props.location.pathname.indexOf("/proj/edit/") == 0) {
        let tmpAry = props.location.pathname.split("/");
        tmpID = tmpAry.pop();
        tmpID = tmpAry.pop();
    }
    const pid = tmpID;
    const { pathname } = useLocation();

    function logout(e) {
        e.stopPropagation();
        e.preventDefault();

        API.Logout()
            .then((data => {
                this.props.history.push(API.login_page);
                // console.log(API.first_page, data);

                // if (!data || !data.code
                // 	|| (22040 != data.code && 22042 != data.code)
                // ) {
                // 	//error
                // 	alert("請確認帳密");
                // } else {
                // 	this.props.history.push(API.first_page);
                // }
            }).bind(this)) // JSON from `response.json()` call
            .catch((error => {
                console.warn(error);
                props.history.push(API.login_page);
            }).bind(this))
    }

    function render() {
        const tmp = "/";
        // const { pid } = this.state;
        // const { isAdmin } = this.state;

        return (
            <Container className="customer-header">
                <Row className="mt-5">
                    <Col>
                        <NavLink to={tmp + "proj/add"} className={pid ? "btn-header selected" : "btn-header"} activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary">建立專案</Button>
                        </NavLink>
                    </Col>
                </Row>

                <Row className="mt-2">
                    <Col>
                        <NavLink to={tmp + "proj/index"} className="btn-header" activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary">專案列表</Button>
                        </NavLink>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <NavLink isActive={() => ['/', '/index'].includes(pathname)} to={tmp + "index"} className="btn-header" activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary">我的帳戶</Button>
                        </NavLink>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <NavLink to={tmp + "charge/index"} className="btn-header" activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary">儲值方案</Button>
                        </NavLink>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <NavLink to={tmp + "charge/calculator"} className="btn-header" activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary">試算器</Button>
                        </NavLink>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col>
                        <NavLink to={tmp + "tutorial"} className="btn-header" activeClassName="selected">
                            <Button className="w-100 bold" variant="secondary" disabled>教學/說明</Button>
                        </NavLink>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col>
                        <NavLink to={tmp + ""} className="btn-header" onClick={logout}>
                            <Button className="w-100 bold" variant="secondary">登出</Button>
                        </NavLink>
                    </Col>
                </Row>
            </Container>
        );
    }
    return render();
}

// class CustomerHeader extends Component {
//     constructor() {
//         super();
//         const { id } = useParams();
//         Tools.init();
//         // this.state = {
//         //     isAdmin: API.getIsAdmin()
//         // }
//         this.logout = this.logout.bind(this);
//         this.state = {
//             pid: id
//         }
//     }

//     logout() {
//         API.Logout()
//             .then((data => {
//                 this.props.history.push(API.login_page);
//                 // console.log(API.first_page, data);

//                 // if (!data || !data.code
//                 // 	|| (22040 != data.code && 22042 != data.code)
//                 // ) {
//                 // 	//error
//                 // 	alert("請確認帳密");
//                 // } else {
//                 // 	this.props.history.push(API.first_page);
//                 // }
//             }).bind(this)) // JSON from `response.json()` call
//             .catch((error => {
//                 console.warn(error);
//                 this.props.history.push(API.login_page);
//             }).bind(this))
//     }

//     render() {
//         const tmp = "/";
//         const { logout } = this;
//         const { pid } = this.state;
//         // const { isAdmin } = this.state;

//         return (
//             <Container className="customer-header">
//                 <Row className="mt-5">
//                     <Col>
//                         <NavLink to={tmp + "proj/add"} className={pid ? "btn-header selected" : "btn-header"} activeClassName="selected">
//                             <Button className="w-100 btn-blue">建立專案</Button>
//                         </NavLink>
//                     </Col>
//                 </Row>

//                 <Row className="mt-2">
//                     <Col>
//                         <NavLink to={tmp + "proj/index"} className="btn-header" activeClassName="selected">
//                             <Button className="w-100 btn-blue">專案列表</Button>
//                         </NavLink>
//                     </Col>
//                 </Row>
//                 <Row className="mt-2">
//                     <Col>
//                         <NavLink to={tmp + "index"} className="btn-header" activeClassName="selected">
//                             <Button className="w-100 btn-blue">我的帳戶</Button>
//                         </NavLink>
//                     </Col>
//                 </Row>
//                 <Row className="mt-1">
//                     <Col>
//                         <NavLink to={tmp + ""} className="btn-header" activeClassName="selected">
//                             <Button className="w-100 btn-xs btn-yellow">教學/說明</Button>
//                         </NavLink>
//                     </Col>
//                 </Row>
//             </Container>
//         );
//     }
// }

// const mapStateToProps = (state) => ({
//     id: state.authReducer.id
// })

// const mapDispatchToProps = {

// }

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(CustomerHeader)